import { render, staticRenderFns } from "./Appreciation.vue?vue&type=template&id=1056c7ba&"
import script from "./Appreciation.vue?vue&type=script&lang=js&"
export * from "./Appreciation.vue?vue&type=script&lang=js&"
import style0 from "./Appreciation.vue?vue&type=style&index=0&id=1056c7ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports